import axios from "axios";

const API_KEEPER = import.meta.env.VITE_API_KEEPER;

const adrCodeService = {
    list: async (payload) => axios.post(API_KEEPER + "/adr-code/search", payload).then(({ data }) => data).catch((err) => { throw err }),
    create: async (payload) => axios.post(API_KEEPER + "/adr-code", payload).then(({ data }) => data).catch((err) => { throw err }),
    update: async (id, payload) => axios.put(API_KEEPER + `/adr-code/${id}`, payload).then(({ data }) => data).catch((err) => { throw err }),
    remove: async (id) => axios.delete(API_KEEPER + `/adr-code/${id}`).then(({ data }) => data).catch((err) => { throw err }),
    get: async (id) => axios.get(API_KEEPER + `/adr-code/${id}`).then(({ data }) => data).catch((err) => { throw err }),
    formatAdrCode: (value) => {
        if (!value) return '';

        let hasX = /[Xx]/.test(value);

        let cleaned = value.replace(/[^0-9]/g, '');

        if (hasX) {
            cleaned = 'X' + cleaned;
        }

        if (cleaned.startsWith('X')) {
            if (cleaned.length <= 4) return cleaned;
            return `${cleaned.slice(0, 4)} ${cleaned.slice(4, 8)}`;
        }

        if (cleaned.length <= 3) return cleaned;

        if (cleaned.length <= 6) {
            return `${cleaned.slice(0, 2)} ${cleaned.slice(2)}`;
        }

        if (cleaned.length >= 7) {
            return `${cleaned.slice(0, 3)} ${cleaned.slice(3, 7)}`;
        }

        return `${cleaned.slice(0, 2)} ${cleaned.slice(2, 6)}`;
    },
    normalizeAdrCode: (value) => {
        if (!value) return null;
        return value.replace(/[^0-9xX]/g, '');
    }
}

export default adrCodeService;